var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"border",staticStyle:{"resize":"vertical","overflow":"auto","max-height":"100ex"}},[_c('pre',{staticClass:"bg-white px-1 py-3"},[_vm._v(_vm._s(this.audit_log))])])
}
var staticRenderFns = []

export { render, staticRenderFns }